module.exports = __webpack_public_path__ + "img/mission_content.6f8b65c3.png";